import { Component, input, model } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

export interface TabItem {
  id: string;
  labelKey?: string;
  label?: string;
  /** Muted suffix after the label, e.g. "Montert 3/14". */
  suffix?: string;
}

/** 'underline': design top tabs (Dører / Plantegning / Dashboard). 'segment': pill segmented control. */
export type TabsVariant = 'underline' | 'segment';

@Component({
  selector: 'mbm-tabs',
  templateUrl: './mbm-tabs.component.html',
  styleUrl: './mbm-tabs.component.scss',
  imports: [TranslateModule],
  host: { '[class.mbm-tabs-segment-host]': "variant() === 'segment'" },
})
export class MbmTabsComponent {
  readonly tabs = input.required<TabItem[]>();
  readonly selectedTabId = model.required<string>();
  readonly variant = input<TabsVariant>('underline');

  protected selectTab(tabId: string): void {
    this.selectedTabId.set(tabId);
  }
}
